import styles from "./submit.module.css";
const Submit = () => {
  return (
    <section className={styles.ctn}>
      <h1>How To Submit</h1>
      <div className={styles.stepsBox}>
        <div className={styles.stepsItem}>
          <h3 className={styles.step1}>Step 1</h3>
          <h5>
            Post the video on <span>YouTube or Instagram</span> (which must be set to
            public).
          </h5>
        </div>
        <div className={styles.stepsItem}>
          <h3 className={styles.step2}>Step 2</h3>
          <h5>
            Add <span>#HauToFilmWithZHIYUN @Chris Hau @Zhiyun-Tech</span> in the post.
          </h5>
        </div>

        <div className={styles.stepsItem}>
          <h3 className={styles.step3}>Step 3</h3>
          <h5>
          Submit the link of the video to the email: 
            <span> creatorsclub@zhiyun-tech.com</span>.
          </h5>
        </div>
      </div>
      <a className={styles.note} href="https://www.zhiyun-tech.com/en/service/agreement_detail/73">
        TERMS AND CONDITIONS - CRANE-M3 × CHRIS HAU Short B-roll Challenge
      </a>
    </section>
  );
};

export default Submit;
